customElements.define("wishlist-master",class WishlistMaster extends HTMLElement{
    constructor(){
        super();
        this.wishlistName = "hashcom-wishlist";
        this.wishlistCountBubble = this.findOrCreateCountBubble();
        this.updateCount();
        this.modal;
    }
    attachEventListeners(){
        this.addEventListener('click', (event) => {
            this.toggleModal(event);
        });

        document.addEventListener('wishlist-slave:wishlist-changed', (e) => {
            this.updateCount();
            this.updateModal(e.detail.action, e.detail.slave.productHandle);
        });
    }
    toggleModal(event){
        let outerModalClicked = this.querySelector(".wishlist-modal") === event.target;
        let closeButtonClicked = this.modal.querySelector(".wishlist-close").contains(event.target);
        let shouldOpen = (this.modal.opened && ((!outerModalClicked) && !closeButtonClicked)) || this.modal.opened == false;
        document.body.classList.toggle("overflow-hidden",shouldOpen);
        this.modal.classList.toggle("opened",shouldOpen);
        this.modal.classList.toggle("closed",!shouldOpen);
        this.modal.opened = !this.modal.opened;
        if(this.modal.opened){this.fillModalWithProducts();}
    }
    updateCount(){
        let count = this.countWishlist();
        this.wishlistCountBubble.textContent = count == 0 ? "": count;
    }
    countWishlist(){
        return Object.keys(this.getWishlist()).length;
    }
    getWishlist(){
        let wishlist = JSON.parse(localStorage.getItem(this.wishlistName));
        // if wishlist doesnt exist, set it
        if(!wishlist){
            wishlist = {};
            this.setWishlist(wishlist);
        }
        return wishlist;
    }
    setWishlist(wishlist){
        return localStorage.setItem(this.wishlistName, JSON.stringify(wishlist));
    }
    findOrCreateCountBubble(){
        let bubble = this.querySelector(".wishlist-count-bubble span");
        if(!bubble){
            let shadowNode = document.createElement("div");
            shadowNode.classList.add("wishlist-count-bubble");
            shadowNode.innerHTML = `<span></span>`;
            this.appendChild(shadowNode);
            bubble = this.querySelector(".wishlist-count-bubble span");
        }

        return bubble;

    }

    generateWishlistSlave(){
        let slave = document.createElement("wishlist-slave");
        slave.innerHTML = `
        <svg preserveAspectRatio="none" id="wishlist" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49 40">
            <path fill="none" stroke="#8a7e70" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M 24.493 10.648 L 14.942 1.47 L 1.723 14.812 L 24.5 38.531 L 47.27 14.812 L 34.052 1.472 L 24.5 10.652"/>
        </svg>
        `;
        return slave;
    }

    updateModal(action, handle){
        if(action == "remove"){
            let element = this.modal.querySelector(`.wishlist-mainCardContent [product-handle*="${handle}"]`);
            element.classList.add("reduce-opacity");
            setTimeout(() => {
                element.remove();
            }, 500);
        }else if(action == "add"){
            this.fillModalWithProducts();
        }
    }
    createWishlistModal(){
        let modal = document.createElement("div");
        modal.setAttribute("class","wishlist-modal closed");
        modal.innerHTML = `
        <div class="wishlist-mainCard">
          <div class="wishlist-mainCardHeader">
            <div class="wishlist-title">
                <h2>Wishlist</h2>
                <div class="wishlist-close">
                </div>
            </div>
          </div>
          <div class="wishlist-mainCardContent"></div>
          <p class="wishlist-empty_text">Your wishlist is empty..</p>
        </div>
        `;
        this.appendChild(modal);
        this.modal = modal;
        this.modal.opened = false;

    }

    fillModalWithProducts(){
        let wishlist = this.getWishlist();
        Object.entries(wishlist).forEach((item) => {
            let key = item[0];
            let value = item[1];

            //check if product card is already in modal
            let card = this.querySelector(`.wishlist-mainCardContent [product-handle*="${key}"]`)
            if(card !== null){
                if(card.style.order < value.added_at) card.style.order = value.added_at; //check if timestamp / order is up to date
            }else{
                let url = `${window.Shopify.routes.root}products/${key}.json`;
                fetch(url,{
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json'
                      },
                })
                .then(res => res.json())
                .then((res) => {
                    this.addProductCardInModal(this.createProductCard(res.product,value.added_at));
                })
                .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${key}`, err));
            }

        })
    }

    addProductCardInModal(carditem){
        this.modal.querySelector(`.wishlist-mainCardContent`).appendChild(carditem);
    }

    createProductCard(product, order = 0){
        let miniCard = document.createElement("div");
        miniCard.setAttribute("class","wishlist-miniCard-wrapper");
        miniCard.style.order = order;
        miniCard.setAttribute("product-handle",product.handle);
        let price = new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify.currency.active }).format(Math.min.apply(null,product.variants.map((item) => {return Number(item.price).toFixed(2)})).toFixed(2));
        miniCard.innerHTML = `
        <div class="wishlist-miniCard">
            <div class="image-wrapper">
                <a href="${window.Shopify.routes.root}products/${product.handle}" class="wishlist-item_link">
                    <img class="wishlist-item_image" src="${product.image.src}">
                </a>
            </div>
            <div class="wishlist-icon_wrapper">
            </div>
            <div class="wishlist-item_title">
                <a class="wishlist-item_link" href="${window.Shopify.routes.root}products/${product.handle}">${product.title}</a>
                <div >
                    <span>${price}</span></div>
                </div>
            </div>
            
        </div>
        `;
        miniCard.querySelector(".wishlist-icon_wrapper").appendChild(this.generateWishlistSlave());
        return miniCard;
    }


    connectedCallback(){
        this.attachEventListeners();
        this.createWishlistModal();
    }
});









customElements.define("wishlist-slave",class WishlistSlave extends HTMLElement{
    constructor(){
        super();
        this.wishlistName = "hashcom-wishlist";
    }
    getProductHandle(){
        let handle = this.getAttribute("product-handle");
        if(!handle){
            let elementWithLink = this.closest('*:has(a)').querySelector("a[href*='/products/']");
            let link = elementWithLink.getAttribute("href");
            handle = this.getHandleFromUrl(link);
        }else{
            handle = this.getHandleFromUrl(handle);
        }
        return handle;
    }
    getHandleFromUrl(str){
        let splitted_link = str.split('?')[0].split('products/');
        let handle = splitted_link[splitted_link.length-1];
        return handle;
    }
    onClick(){
       this.toggleStatus();
    }
    toggleStatus(){
        //check if handle is in wishlist
        if(this.checkHandleInWishlist()){
            //remove from wishlist
            this.removeFromWishlist();
        }else{
            //add to wishlist
            this.addToWishlist();
        }
    }
    addToWishlist(){
        let wishlist = this.getWishlist();
        wishlist[this.productHandle] = {
            added_at : Date.now(),
            added_location : window.location.href
        }
        this.classList.add("wishlist-added");
        this.setWishlist(wishlist);
        this.dispatchUpdatedEvent("add");
    }
    removeFromWishlist(){
        let wishlist = this.getWishlist();
        delete wishlist[this.productHandle];
        this.classList.remove("wishlist-added");
        this.setWishlist(wishlist);
        this.dispatchUpdatedEvent("remove");
    }
    checkHandleInWishlist(){
        let wishlist = this.getWishlist();
        if(!wishlist[this.productHandle]){
            return false;
        }else{
            return true;
        }
    }

    updateState(){
        //check if handle is in wishlist
        if(this.checkHandleInWishlist()){
            //add class
            this.classList.add("wishlist-added");
        }else{
            //remove class
            this.classList.remove("wishlist-added");
        }
    }

    getWishlist(){
        let wishlist = JSON.parse(localStorage.getItem(this.wishlistName));
        // if wishlist doesnt exist, set it
        if(!wishlist){
            wishlist = {};
            this.setWishlist(wishlist);
        }
        return wishlist;
    }
    setWishlist(wishlist){
        localStorage.setItem(this.wishlistName, JSON.stringify(wishlist));
    }

    dispatchUpdatedEvent(action){
        this.dispatchEvent(new CustomEvent('wishlist-slave:wishlist-changed', { 
            bubbles: true,
            detail: {
                slave: this,
                action: action
            }
        }));
    }
    connectedCallback(){
        this.productHandle = this.getProductHandle();
        this.classList.toggle("wishlist-added",this.checkHandleInWishlist());
        this.attachEventListeners();
    }
    attachEventListeners(){
        this.addEventListener('click', (e) => {
            this.onClick(e);
        });

        document.addEventListener('wishlist-slave:wishlist-changed', (e) => {
            if (this.productHandle === e.detail.slave.productHandle){
                this.updateState();
            }
        });
    }
});
